export const confirmationDg = `
<div class="screen-overlay cfm-overlay">
	<div class="cfm-confirmationBox dialog" >
		<div class="cfm-message"></div>
		<div class="cfm-buttonsDiv">
			<button class='cfm-confirm-ok'>Confirm</button>
			<button class='cfm-confirm-cancel'>Cancel</button>
		</div>
	</div>
</div>
`;